import { render, staticRenderFns } from "./DynamicQuestion.vue?vue&type=template&id=369b1df4&"
import script from "./DynamicQuestion.vue?vue&type=script&lang=js&"
export * from "./DynamicQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports